import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { component, componentAddEventListener, html, TemplateResult, unsafeHTML, useEffect, useState } from "../../tools/utilities/component";
import { generateIcon, getCurrentCart, ON_CART_FINISHED, ON_CART_PENDING, printMoney, t } from '@process-creative/slate-theme-tools';
import { cartLineCreate } from "./cart-line";
import { CLASS_IS_EMPTY } from './../../tools/constants/classes';
import { cartUpsellCreate, setupScrollEvent, storeUpsellProducts } from './cart-upsell';
import { shippingProgressBarCreate } from "./cart-shipping-progress";
import { LineItem } from "../../tools/cart/line-item";
import { Cart } from '../../tools/cart/cart'; // Attributes

var ATTR_MIN_SPEND = 'data-shipping-min-spend';
var ATTR_UPSELL = 'data-drawer-upsell'; // const SELECTOR_ORDER_NOTE = '[data-order-note]';
// const SELECTOR_ORDER_BOOKLET = '[data-order-booklet]'

/**
 * The state of the cart component
 */

/**
 * Returns the different cart states as an object
 * @returns An object containing the different states and their setters
 */
var cartState = function cartState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pending = _useState2[0],
      setPending = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      cartUpsell = _useState4[0],
      setCartUpsell = _useState4[1]; // We'll compare the json to ensure that the cart updates correctly


  var _useState5 = useState(JSON.stringify(getCurrentCart())),
      _useState6 = _slicedToArray(_useState5, 2),
      jCart = _useState6[0],
      setJCart = _useState6[1];

  var _useState7 = useState(getCurrentCart()),
      _useState8 = _slicedToArray(_useState7, 2),
      cart = _useState8[0],
      setCartInternal = _useState8[1];

  useEffect(function () {
    setCartInternal(JSON.parse(jCart));
  }, [jCart]);
  useEffect(function () {
    if (cartUpsell) {
      setupScrollEvent();
    }
  }, [cartUpsell]);

  var setCart = function setCart(cart) {
    var strCart = JSON.stringify(cart);
    if (strCart === jCart) return;
    setJCart(strCart);
  };

  return {
    cart: cart,
    setCart: setCart,
    pending: pending,
    setPending: setPending,
    cartUpsell: cartUpsell,
    setCartUpsell: setCartUpsell
  };
};

component({
  name: 'cart-drawer',
  class: 'c-cart-drawer',
  render: function render(self) {
    // Shorthand methods
    var ut = function ut(s, variables) {
      return unsafeHTML(t(s, variables));
    }; // Attributes


    var minSpendAttr = self.getAttribute(ATTR_MIN_SPEND);
    var upsellAttr = self.getAttribute(ATTR_UPSELL); // State

    var state = cartState(); // Listen for changes to the cart and update the state to reflect

    componentAddEventListener(ON_CART_PENDING, function (e) {
      return state.setPending(true);
    });
    componentAddEventListener(ON_CART_FINISHED, function (e) {
      state.setCart(getCurrentCart());
      state.setPending(false);
    }); // Generate upsell

    var itemProductId = state.cart.items.length > 0 ? state.cart.items[0].product_id : 0;

    var updateUpsell = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var storedUpsellProducts;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return storeUpsellProducts(upsellAttr, itemProductId, state.cart.items);

              case 2:
                storedUpsellProducts = _context.sent;

                if (!storedUpsellProducts) {
                  _context.next = 9;
                  break;
                }

                _context.t0 = state;
                _context.next = 7;
                return cartUpsellCreate(storedUpsellProducts);

              case 7:
                _context.t1 = _context.sent;

                _context.t0.setCartUpsell.call(_context.t0, _context.t1);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function updateUpsell() {
        return _ref.apply(this, arguments);
      };
    }();

    useEffect(function () {
      updateUpsell();
    }, [state.cart]); // Generate shipping progress bar

    var shippingBar = shippingProgressBarCreate(minSpendAttr, state.cart.items_subtotal_price); // Set drawer empty class

    if (state.cart.item_count <= 0) {
      self.classList.add(CLASS_IS_EMPTY);
      state.setCartUpsell(undefined);
    } else {
      self.classList.remove(CLASS_IS_EMPTY);
    } // Generate the cart line items


    var items = state.cart.items;
    var lines = items.map(function (item, index) {
      var _item$properties, _item$properties2;

      if (item !== null && item !== void 0 && (_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties._isChildProduct) return '';
      var bundleProducts;
      var bundleId = (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2.isProductBundle;

      if (bundleId) {
        bundleProducts = items.filter(function (i) {
          return i.properties._isChildProduct == bundleId;
        });
      }

      return cartLineCreate({
        item: item,
        index: index,
        disabled: state.pending,
        bundleProducts: bundleProducts,
        state: state
      });
    });
    var itemsTemplate = html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <div class=\"c-cart-drawer__lines-container\" data-lines-container>\n        <div class=\"c-cart-drawer__lines\" data-cart-lines>\n          ", "\n        </div>\n      </div>\n    "])), lines);
    var emptyCartTemplate = html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <div class=\"c-cart-empty\">\n        <p class=\"c-cart-empty__heading o-type--4\">\n          ", "\n        </p>\n      </div>\n    "])), ut('cart.empty_heading'));
    var cartLines = state.cart.item_count ? itemsTemplate : emptyCartTemplate;
    var pointsMsg = t('cart.loyalty_message');
    pointsMsg = pointsMsg.replace('%points%', "<span data-lion-points-for=\"".concat(state.cart.total_price, "\"></span>"));
    var cn = t('cart.notes');
    var cnString = cn + '';
    return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      <header class=\"c-cart-drawer__header\">\n        <h4 class=\"c-cart-drawer__title\">\n          ", "\n        </h4>\n        <span class=\"c-cart-drawer__close\" data-cart-drawer-toggle>\n          ", "\n        </span>\n      </header>\n\n      ", "\n\n      ", "\n\n      <footer class=\"c-cart-drawer__footer\">\n\n        <p class=\"c-cart-drawer__footer-loyalty\">\n        ", "\n        </p>\n       \n        <div class=\"c-cart-drawer__footer-inner\">\n          <div class=\"c-cart-drawer__subtotal-row\">\n            <p class=\"c-cart-drawer__subtotal \">\n              ", "\n              <shop-money money=\"", "\">", "</shop-money>\n            </p>\n          </div>\n\n\n          <div class=\"c-cart-drawer__btn-row\">\n            <a href=\"/checkout\"\n              class=\"c-cart-drawer__btn is-checkout-btn o-btn is-secondary\"\n            >\n              <span class=\"o-btn__inner\">\n                ", "\n              </span>\n            </a>\n\n          </div>\n        </div>\n\n        ", "\n      </footer>\n    "])), ut('cart.title'), unsafeHTML(generateIcon('cross', "c-cart-drawer__close-icon", 'Close Cart', 'Close Cart')), shippingBar, cartLines, unsafeHTML(pointsMsg), t('cart.subtotal'), state.cart.total_price, printMoney(state.cart.total_price), ut('cart.go_to_checkout'), state.cartUpsell);
    /*
    <a href="/cart"
    class="c-cart-drawer__btn is-tertiary o-btn"
    >
    ${ut('cart.view_cart')}
    </a>
    */
  }
});